import React from 'react'
import '../assets/styles/toheader.css'

const Heading = ({ headingText, categoryText }) => {
  return (
    <div>
      <ol className="breadcrumb">
        <li><a href="/">Home</a></li>
        {categoryText && categoryText !== 'all' && (
          <li><a href={`/table/category/${categoryText}/all`}>{categoryText}</a></li>
        )}
        {headingText && headingText !== categoryText && (
          <li className="active">{headingText}</li>
        )}
      </ol>
    </div>
  )
}

export default Heading
